export const selectSubscription = (state) => state.subscription

export const selectSubscriptionData = (state) => state.subscription.data

export const selectSubscriptionBundle = (state) =>
  state.subscription.data.bundle

export const selectSubscriptionFrequency = (state) =>
  state.subscription.data.frequency

export const selectSubscriptionVariants = (state) =>
  state.subscription.data.variants

export const selectSubscriptionUpgrades = (state) =>
  state.subscription.data.upgrades

export const selectSubscriptionUpsells = (state) =>
  state.subscription.data.upsells

export const selectSubscriptionMix = (state) => state.subscription.mix

export const selectSubscriptionNavigation = (state) =>
  state.subscription.navigation

export const selectSubscriptionStep = (state) =>
  state.subscription.navigation.step

export const selectSubscriptionSizeSubSteps = (state) =>
  state.subscription.navigation.sizeSubSteps

export const selectSubscriptionPatternSubSteps = (state) =>
  state.subscription.navigation.patternSubSteps
